import React from 'react';

function TapahtumatSection() {
  return (
    <>
      <p>
        Pulinan perimmäinen tarkoitus on luoda paikka, jossa ihmiset voivat jakaa harrastuksensa ja mielenkiinnon
        kohteensa muiden kanssa. Tapahtumia voivat luoda kaikki käyttäjät ja ne voivat olla olla Live Stream- tai
        ennalta luotuja videoita. Tapahtumien aikana, tapahtumiin osallistuvilla on oma chätti, jonka halutessaan voi
        viedä vaikka toiseen ikkunaan.
      </p>
    </>
  );
}

export default TapahtumatSection;

